import React, { useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import Changemass from "../images/ControlPanel.webp";
import { FaChevronDown } from 'react-icons/fa';
import Glace from "../images/exq.jpg";
import Slider from "react-slick";
import Trusted from "../images/TR.png";
import Personilized from "../images/Personilized.png";
import Secure from "../images/1746650.png";
import Energy from "../images/png-clipart-energy-conservation-computer-icons-energy-text-loan-thumbnail.png";
import Seam from "../images/6407238.png";
import SE from "../images/Gemini_Generated_Image_yq4dn1yq4dn1yq4d.png";
import TP from "../images/Gemini_Generated_Image_6v2h4p6v2h4p6v2h.png";
import Control from "../images/ntworkand .jpg";
import SmartHomeVideo from "../videos/video.mp4";
import Damac from '../images/Damac.jpg';
import { FaMapMarkerAlt } from "react-icons/fa";

import Alshafi from '../images/Alshafi.jpg';
import TCF from '../images/TCF.png';
import tuya from '../images/1200x600wa.png';
import flac from '../images/7921226.png';
import Telescope from '../images/Telescope.jpg';
import Yasser from '../images/Yasser.png';
import TimeZone from '../images/TimeZone.jpg';
import MapCanada from '../images/MapCanada.a3d6d1e91126c7771748.jpg';
import Hammer from '../images/Hammer.jpg';
import Lucera from '../images/Lucera.jpg';
import Leen from '../images/lenn.jpg';
import Dubai from '../images/futuristic-dubai-landscape.jpg';
import Amman from '../images/Abdali.jpg';
import Vibranum from '../images/vibranum.cfe097443564d53e819f.jpg';
import IRIS from '../images/Iris.jpg';
import Concept from '../images/Maa.png';
import Sth from '../images/Updated_SmartThings_Logo.png';
import Xi from '../images/xiaomi-new-2021-logo-png_seeklogo-400999.png';
import philips from '../images/Philips-Hue-Logo-digital-2017-Ralitsa-Tencheva.png';
import Ring from '../images/Ring_Inc.-Logo.wine_.png';
import AL from '../images/Alexa-logo.png';
import Google from '../images/Google-Home-Logo-1536x864.png';
import Mass from '../images/Mass Logo Reconstructed.png';
import agency from '../images/31agency.jpg';
import Alfurjan from '../images/Alfurjan.png';
import Zaaabeel from '../images/zaaabeel.jpg';
import PlanB from '../images/planB.jpg';
import Hills from '../images/Gemini_Generated_Image_n02nhgn02nhgn02n.png';
import Albeer from '../images/albeer.jpg';

import AS from '../images/works_with_apple_home-logo_brandlogos.net_ibfdn.png';
import Rahaf from '../images/Rahaf.eb3dfb1394912e02674a.jpg';
import { useLanguage } from '../pages/LanguageContext'; // Use your context if exists
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { FaInstagram, FaFacebookF, FaUsers } from "react-icons/fa";

const glanceTranslations = {
  en: {
    title: "at a Glance",
    tabs: ["About", "Vision", "Mission", "Values"],
    content: {
      About: "Mass Smart Solutions is redefining how the region lives — with cutting-edge automation, intelligent design, and unmatched reliability. Trusted across Jordan. Now building the future in Dubai...",
      Vision: "To lead the smart living revolution across the Middle East — by delivering intelligent, personalized, and future-ready automation experiences that redefine how people live, move, and feel at home...",
      Mission: "To design and deliver seamless smart home solutions that elevate everyday living — by combining advanced technology, tailored automation, and exceptional support for clients across Jordan, the UAE, and beyond...",
      Values: "At Mass Smart Solutions, we value innovation, personalization, and trust. We deliver reliable, tailored smart home experiences with integrity, customer-first support, and a deep commitment to both environmental responsibility and raising the standard of smart living across Jordan, Dubai, and the region...",
    },
  },
  ar: {
    title: "في لمحة",
    tabs: ["من نحن", "الرؤية", "الرسالة", "القيم"],
    content: {
      About: "شركة ماس سمارت سوليوشنز هي شركة رائدة في أتمتة المنازل الذكية، تقدم حلولاً موثوقة ومصممة خصيصاً لأسلوب حياة كل عميل. موثوقون في الأردن، ونوسّع الآن نطاق خدماتنا إلى دبي لتقديم تجربة معيشة ذكية على أعلى مستوى في المنطقة",
      Vision: "أن نكون الروّاد في ثورة المعيشة الذكية في الشرق الأوسط — من خلال تقديم تجارب أتمتة ذكية، مخصصة، وجاهزة للمستقبل تعيد تعريف طريقة عيش الناس وتحركهم في منازلهم",
      Mission: "نصمم ونقدّم حلول منازل ذكية سلسة ترتقي بتجربة الحياة اليومية: عبر دمج التكنولوجيا المتقدمة و أنظمة الأتمتة المصممة حسب الطلب، والدعم المتميز لعملائنا في الأردن و الإمارات، و أبعد من ذلك",
      Values: "في ماس سمارت سوليوشنز، نؤمن بالابتكار، و التخصيص، والثقة. نقدم تجارب ذكية موثوقة ومصممة خصيصاً، مستندين على النزاهة، وأولوية دعم العملاء، والإلتزام التام بالمسؤولية البيئية، والارتقاء بأسلوب الحياة الذكية في الأردن، الإمارات، ومنطقة الشرق الأوسط",
    },
  }
};

const servicesTranslations = {
  en: {
    sectionTitle: "Our Main Services",
    services: [
      {
        title: "Smart Home Setup & Automation",
        description: "Design, installation, and tailored routines — covering lighting, climate, security, and access control",
        link: "/SmartHomeAutomationPage"
      },
      {
        title: " System Support & Maintenance",
        description: "Ongoing assistance, smart troubleshooting, and regular updates — to keep everything smooth, secure, and connected",
        link: "/services/home-security"
      },
      {
        title: " Network & Security Optimization",
        description: "Reliable Wi-Fi coverage, device integration, and network security planning for a stable smart environment",
        link: "/services/industrial-application"
      }
    ]
  },
  ar: {
    sectionTitle: "خدماتنا الرئيسية",
    services: [
      {
        title: "تركيب أنظمة المنزل الذكي",
        description: "تصميم وتنفيذ أنظمة ذكية متكاملة تشمل الإضاءة، التكييف، الأمن، والتحكم في الأبواب والستائر، مع برمجة روتينات مخصصة حسب أسلوب حياة كل عميل",
        link: "/SmartHomeAutomationPage"
      },
      {
        title: " تحسين الشبكة والأمان",
        description: "تخطيط احترافي لتغطية Wi-Fi، ربط الأجهزة الذكية بسلاسة، وتعزيز أمان الشبكة لضمان كفاءة التشغيل و استقرار النظام",
        link: "/services/home-security"
      },
      {
        title: "الدعم والصيانة الذكية",
        description: "مساعدة مستمرة، تشخيص الأعطال عن بُعد، زيارات ميدانية عند الحاجة، وتحديثات دورية للحفاظ على أداء النظام بأعلى كفاءة",
        link: "/services/industrial-application"
      }
    ]
  }
};

const proudTranslations = {
  en: "Proud To Work With",
  ar: "فخورون بالعمل مع",
};

const whyMassTranslations = {
  en: [
    { title: "Trusted Partnerships", image: Trusted },
    { title: "Personalized Solutions", image: Personilized },
    { title: "Secure & Reliable", image: Secure },
    { title: "Energy Efficiency", image: Energy },
    { title: "Seamless Integration", image: Seam },
    {
      title: "Smart Living Experts",
      image: flac,
    },
  ],
  ar: [
    { title: "شراكات موثوقة", image: Trusted },
    { title: "حلول مصممة خصيصاً", image: Personilized },
    { title: "أمان وموثوقية", image: Secure },
    { title: "كفاءة الطاقة", image: Energy },
    { title: "تكامل سلس", image: Seam },
    {title: "خبراء الحياة الذكية",image: flac,},
  ],
};

const clientSectionTranslations = {
  en: {
    clientsCount: '+100 Clients Trust Us',
    pioneers: 'Pioneers Who Trust Us',
    pioneersDesc: "We’re proud to be the smart home partner of choice for innovators, developers, and pioneers across the region. Each logo represents a collaboration built on trust, forward thinking, and a shared commitment to smarter living",
  },
  ar: {
    clientsCount: '+100 عميل يثق بنا',
    pioneers: 'الروّاد الذين يثقون بنا',
    pioneersDesc: 'نفخر بكوننا الشريك المفضل في حلول المنازل الذكية للروّاد والمطوّرين والمبتكرين في مختلف أنحاء المنطقة. كل شعار هنا يعبّر عن شراكة قائمة على الثقة والرؤية المستقبلية والسعي المشترك نحو أسلوب حياة أكثر ذكاء',
  }
};

const partnerLogos = [
  philips,
  Ring,
  Sth,
  Google,
  AS,
  AL,
  Xi,
  tuya,
  TP
];

const SmartHomeIntro = () => {
  const { language} = useLanguage();
  
  const isAr = language === 'ar';
  const currentServices = servicesTranslations[isAr ? "ar" : "en"];
  const [clients, setClients] = useState(0);
const [insta, setInsta] = useState(0);
const [fb, setFb] = useState(0);

useEffect(() => {
  const animateValue = (setter, end, duration) => {
    let start = 0;
    const increment = end / (duration / 16);
    const step = () => {
      start += increment;
      if (start < end) {
        setter(Math.floor(start));
        requestAnimationFrame(step);
      } else {
        setter(end);
      }
    };
    step();
  };

  animateValue(setClients, 100, 1200);
  animateValue(setInsta, 33100, 1500);
  animateValue(setFb, 1800, 1700);
}, []);
useEffect(() => {
  // ...your other styles here...
  const floatAnim = document.createElement('style');
  floatAnim.innerHTML = `
    @keyframes floatUpDown {
      0% { transform: translateY(0); }
      50% { transform: translateY(-10px);}
      100% { transform: translateY(0);}
    }
  `;
  document.head.appendChild(floatAnim);
  return () => document.head.removeChild(floatAnim);
}, []);

  const navigate = useNavigate();
  const [heroStep, setHeroStep] = useState(0);
  
  useEffect(() => {
    const timer = setTimeout(() => {
    setHeroStep((prev) => 1 - prev); // Only 0 and 1
  }, 7000); // 7 seconds

  return () => clearTimeout(timer);
}, [heroStep]);


const [showScrollTop, setShowScrollTop] = useState(false);

useEffect(() => {
  const handleScroll = () => {
    setShowScrollTop(window.scrollY > 300);
  };

  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, []);

useEffect(() => {
  const style = document.createElement('style');
  style.innerHTML = `
    .cta-button {
      position: relative;
      overflow: hidden;
      border: 3px solid #1a4bb7;
      border-radius: 30px;
      padding: 0.8rem 2rem;
      background-color: transparent;
      color: #fff;
      font-weight: 600;
      font-size: 1.1rem;
      cursor: pointer;
      transition: color 0.3s ease;
    }
    .cta-button::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 100%;
      background-color: #fff;
      z-index: 0;
      transition: width 0.4s ease;
    }
    .cta-button:hover::before {
      width: 100%;
    }
    .cta-button:hover {
      color:rgb(42, 91, 199);
    }
   .cta-button span {
  position: relative;
  z-index: 1;
  color: white;
  text-shadow:
    -1px -1px 0 #000,
     1px -1px 0 #000,
    -1px  1px 0 #000,
     1px  1px 0 #000;
}
     .animated-gradient-title {
  font-size: clamp(1.2rem, 2.5vw, 2.2rem); /* 👈 make smaller */
  font-weight: 600;
  text-align: center;
  background: linear-gradient(270deg,rgb(26, 61, 136),rgb(44, 113, 188),rgb(48, 71, 119));
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientShift 8s ease infinite;
  line-height: 1;
}
@keyframes gradientShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
     @media (max-width: 700px) {
  .heroOverlay {
    padding: 0 0.4rem !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    justify-content: center !important;
  }
  .heroSubline {
    display: none !important;
  }
  .heroTitle {
    font-size: 1.3rem !important;
    font-weight: 700 !important;
    margin-bottom: 1.1rem !important;
    text-shadow: none !important;
    color: #fff !important;
    line-height: 1.2 !important;
  }
  .cta-button {
    font-size: 1rem !important;
    padding: 0.7rem 1.2rem !important;
    min-width: 150px;
    margin-top: 0.6rem !important;
  }
    @media (max-width: 700px) {
  .trusted-title {
    font-size: 1.6rem !important;
    padding: 0 !important;
    margin: 0 !important;
    display: inline-block;
    position: relative;
  }

  .trusted-title span {
    display: inline-block;
    padding: 0.4rem 0.6rem;
    position: relative;
  }

  .trusted-title::before {
    content: "";
    position: absolute;
    width: 18px;
    height: 3px;
    top: 0;
    right: 0;
    background: linear-gradient(90deg, #1784e6, #1a4bb7);
  }

  .trusted-title::after {
    content: "";
    position: absolute;
    width: 3px;
    height: 18px;
    top: 0;
    right: 0;
    background: linear-gradient(180deg, #1784e6, #1a4bb7);
  }

  html[dir="rtl"] .trusted-title::before {
    left: 0 !important;
    right: auto !important;
  }

  html[dir="rtl"] .trusted-title::after {
    left: 0 !important;
    right: auto !important;
  }
}

}
  `;
  document.head.appendChild(style);
  return () => {
    document.head.removeChild(style);
  };
}, []);

useEffect(() => {
  const style = document.createElement('style');
  style.innerHTML = `
    .dark .why-mass-icon {
      filter: brightness(0) invert(1) grayscale(0.2) !important;
      transition: filter 0.3s;
    }
    .dark .why-mass-text {
      color: #fff !important;
      transition: color 0.3s;
    }
  `;
  document.head.appendChild(style);
  return () => document.head.removeChild(style);
}, []);

useEffect(() => {
  const style = document.createElement('style');
  style.innerHTML = `
.partial-border-title {
display: inline-block;
position: relative;
padding: 0.6rem 1.5rem 0.6rem 0.6rem;
font-weight: 800;
border-radius: 0 17px 0 0;
color: inherit;
background: none;
border: none;
outline: none;
text-align: left;
background-clip: padding-box;
font-size: 2.2rem; /* <-- Unified text size */
}
.partial-border-title::before,
.partial-border-title::after {
content: "";
position: absolute;
pointer-events: none;
opacity: 1;
}
.partial-border-title::before {
top: 0;
right: 0;
width: 28px;
height: 5px;
background: linear-gradient(90deg, #1784e6 0%, #1a4bb7 100%);
border-radius: 0 0px 0 0;
}
.partial-border-title::after {
top: 0;
right: 0;
width: 5px;
height: 25px;
background: linear-gradient(180deg, #1784e6 0%, #1a4bb7 100%);
border-radius: 0 0 0px 0;
}
@media (max-width: 700px) {
.partial-border-title {
padding: 0.5rem 0.8rem 0.5rem 0.5rem;
font-size: 1.6rem !important;
}
.partial-border-title::before { width: 18px; height: 3.5px; }
.partial-border-title::after { width: 3.5px; height: 18px; }
}

  `;
  document.head.appendChild(style);
  return () => {
    document.head.removeChild(style);
  };
}, []);

  const [activeTab, setActiveTab] = useState(
  glanceTranslations[isAr ? "ar" : "en"].tabs[0]
);

useEffect(() => {
  setActiveTab(glanceTranslations[isAr ? "ar" : "en"].tabs[0]);
}, [isAr]);

  

  const carouselSettings = {
    infinite: true,
    centerMode: true,
    centerPadding: "60px",
    slidesToShow: 3,
    speed: 900,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1200,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "30px",
        },
      },
    ],
  };

useEffect(() => {
  document.body.style.margin = '0';
  document.body.style.padding = '0';
  document.body.style.overflowX = 'hidden';

  const styleSheet = document.styleSheets[0];
  const insertRuleSafely = (rule) => {
    try {
      styleSheet.insertRule(rule, styleSheet.cssRules.length);
    } catch (err) {
      console.warn("Error inserting rule:", rule, err);
    }
  };
  
  const stylesToAdd = [
    `@keyframes scrollLeft {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }`,
    `@keyframes bounce {
      0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
      40% { transform: translateY(-10px); }
      60% { transform: translateY(-5px); }
    }`,
    `.scroll-icon:hover {
      transform: scale(1.1);
      background-color: rgba(255, 255, 255, 0.25);
    }`,
    `.hero, .hero video {
      animation: none !important;
      transform: none !important;
    }`,
    `body {
      overflow-x: hidden !important;
    }`,
    `@media (max-width: 768px) {
  .hero {
    height: 35vh !important;
    min-height: 35vh !important;
  }

  .hero img{
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
  }
.hero video {
width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
}
  .slider-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
  .slider-track {
  display: flex;
  width: 300%;
  height: 100%;
  transition: transform 1s ease-in-out;
}
}`
,
    `@keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }`,
    `@keyframes fadeInCard {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }`,
    `@keyframes pulseGlow {
      0% {
        text-shadow: 0 0 0px rgba(26, 75, 183, 0.4);
        transform: scale(1);
      }
      50% {
        text-shadow: 0 0 18px rgba(26, 75, 183, 0.8);
        transform: scale(1.05);
      }
      100% {
        text-shadow: 0 0 0px rgba(26, 75, 183, 0.4);
        transform: scale(1);
      }
    }`, 
        `h2 span::after {
      content: '';
      display: block;
      width: 60%;
      height: 3px;
      background-color: #1a4bb7;
      margin: 0.4rem auto 0;
      animation: underlineFade 1.5s ease-in-out forwards;
    }`,

    `@keyframes underlineFade {
      0% { width: 0; opacity: 0; }
      50% { width: 30%; opacity: 1; }
      100% { width: 60%; opacity: 1; }
    }`,
    `h2.enhanced-title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  text-align: center;
  background: linear-gradient(to right, #1a4bb7, #00ffc3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: fadeInUp 2s ease-out;
  position: relative;
  letter-spacing: 1px;
  line-height: 1.3;
}`,

`h2.enhanced-title span {
  display: inline-block;
  position: relative;
}`,

`h2.enhanced-title span::after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  bottom: -5px;
  width: 100%;
  height: 5px;
  background: rgba(0, 255, 195, 0.3);
  border-radius: 4px;
  animation: underlineFade 1.5s ease-in-out forwards;
}`,

`@keyframes underlineFade {
  0% { width: 0; opacity: 0; }
  50% { width: 50%; opacity: 1; }
  100% { width: 100%; opacity: 1; }
}`,
`h2.styled-header {
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 800;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
  line-height: 1.2;
}`,

`h2.styled-header .underline {
  position: relative;
  display: inline-block;
  padding-bottom: 0.2rem;
}`,

`h2.styled-header .underline::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 4px;
  border-radius: 3px;
  background-color:rgb(38, 106, 179);
  opacity: 0.6;
  animation: underlineGrow 1.5s ease-in-out forwards;
}`,

`@keyframes underlineGrow {
  0% { width: 0; opacity: 0; }
  50% { width: 50%; opacity: 0.8; }
  100% { width: 100%; opacity: 1; }
}`,

`h2.styled-header .black {
  color: #000;
}`,

`h2.styled-header .blue {
  color: #1a4bb7;
}`,

`h2.styled-header .gradient {
  background: linear-gradient(90deg, #1a4bb7,rgb(22, 97, 150));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}`,

`h2.styled-header .plain {
  font-weight: 700;
  color: #0077b6;
}`,
`@media (max-width: 768px) {
  .glanceSection {
    flex-direction: column !important;
    background-image: none !important;
    padding: 1rem !important;
  }
    

  .glanceSection::before {
    content: '';
    display: block;
    width: 100%;
    height: 220px;
    background-image: url(${Glace});
    background-size: cover;
    background-position: center;
    border-radius: 12px;
    margin-bottom: 1rem;
  }

  .glanceSection div {
    text-align: center !important;
    margin: 0 auto !important;
  }
    

  @media (max-width: 700px) {
  .logoScrollInner {
    animation-duration: 20s !important; /* slower on mobile */
    min-width: 1250% !important;         /* make it wider so loop is smooth */
    gap: 35px !important;               /* smaller gap on mobile */
  }
}

}`,

  ];

  const rules = Array.from(styleSheet.cssRules).map(rule => rule.cssText || "");
  stylesToAdd.forEach(rule => {
    if (!rules.some(r => r.includes(rule.split(' ')[0]))) insertRuleSafely(rule);
  });
}, []);


return (
    <main style={{ width: '100%', overflowX: 'hidden' }}>
<section
  className="hero"
  style={{
    ...styles.hero,
    minHeight: '92vh',
    padding: 0,
    justifyContent: 'center',
    alignItems: 'center',
    background:
      heroStep === 0
        ? `url(${Dubai}) center/cover no-repeat`
        : `url(${Amman}) center/cover no-repeat`,
    position: 'relative',
    transition: 'background 0.6s',
  }}
>
  {/* Overlay and Content for Step 0 and Step 1 */}
  <>
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(90deg,rgba(10,34,85,.55) 0%,rgba(19,51,120,.22) 100%)',
        zIndex: 1,
      }}
    />
    <div
      className="heroOverlay"
      style={{
        ...styles.heroOverlay,
        zIndex: 2,
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      {heroStep === 0 && (
        <>
          <p className="heroSubline" style={styles.heroSubline}>
            {isAr
              ? "نفتخر بتوسيع خبراتنا إلى قلب الابتكار"
              : "Proudly extending our expertise to the heart of innovation"}
          </p>
          <h1 className="heroTitle" style={styles.heroTitle}>
            {isAr ? "توسيع آفاقنا ماس الآن في دبي" : "Expanding Horizons Mass is in Dubai"}
          </h1>
          <button className="cta-button" onClick={() => navigate('/contact')}>
            <span>{isAr ? "المزيد ←" : "Learn More →"}</span>
          </button>
        </>
      )}

      {heroStep === 1 && (
        <>
          <p className="heroSubline" style={styles.heroSubline}>
            {isAr
              ? "من الراحة إلى التحكم — نجعل المنازل تفكر."
              : "From comfort to control — we make homes think."}
          </p>
          <h1 className="heroTitle" style={styles.heroTitle}>
            {isAr ? "خبراء المنزل الذكي في الأردن" : "Jordan’s Trusted Smart Home Experts"}
          </h1>
          <button className="cta-button" onClick={() => navigate('/contact')}>
            <span>{isAr ? "المزيد ←" : "Learn More →"}</span>
          </button>
        </>
      )}
    </div>
  </>

  {/* Navigation arrows */}
  <button
    className="fancy-arrow-btn"
    onClick={() => setHeroStep((prev) => (prev === 0 ? 1 : prev - 1))}
    style={{ ...styles.arrowButton, left: '18px' }}
    aria-label="Previous slide"
  >
    <FaChevronLeft size={38} style={{ strokeWidth: 2.5 }} />
  </button>
  <button
    className="fancy-arrow-btn"
    onClick={() => setHeroStep((prev) => (prev + 1) % 2)}
    style={{ ...styles.arrowButton, right: '18px' }}
    aria-label="Next slide"
  >
    <FaChevronRight size={38} style={{ strokeWidth: 2.5 }} />
  </button>

  {showScrollTop && (
    <div
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      style={styles.scrollTopBtn}
      className="scroll-icon"
    >
      <FaChevronDown size={20} style={{ transform: 'rotate(180deg)' }} />
    </div>
  )}
</section>



<section
  style={{
    width: "100%",
    minHeight: 480,
    display: "flex",
    flexDirection:
      window.innerWidth > 900
        ? (isAr ? "row" : "row-reverse")
        : "column",
    alignItems: "center",
    justifyContent: "center",
    gap: window.innerWidth > 900 ? "8vw" : "2.5rem",
    padding:
      window.innerWidth > 900
        ? "8rem 0"
        : "4rem 0 2.6rem 0",
    position: "relative",
    zIndex: 1,
    overflow: "visible"
  }}
>
  {window.innerWidth > 900 ? (
    <>
      {/* Desktop: Video */}
      <div style={{
        flex: "0 0 640px",
        width: 650,
        aspectRatio: "16/9",
        borderRadius: 38,
        overflow: "hidden",
        background: "#193068",
        boxShadow: "0 8px 40px #19306814,0 1.5px 6px #2151a711",
        border: "4px solid #1a4bb7",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: 0,
        padding: 0,
        zIndex: 2,
        position: "relative"
      }}>
        <video
          src={SmartHomeVideo}
          autoPlay
          loop
          muted
          playsInline
          controls={false}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 34,
            background: "#1a2a4f",
            boxShadow: "none",
            border: "none"
          }}
        />
      </div>

      {/* Desktop: Text */}
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: isAr ? "flex-end" : "flex-start",
        justifyContent: "center",
        direction: isAr ? "rtl" : "ltr",
        textAlign: isAr ? "right" : "left",
        zIndex: 3,
        margin: 0,
        maxWidth: 520,
        width: "100%",
        padding: "1.4rem 0",
        background: "none",
        position: "relative"
      }}>
        <h2 style={{
          fontWeight: 800,
          fontSize: '2.7rem',
          letterSpacing: isAr ? 0 : '-.008em',
          textAlign: isAr ? 'right' : 'left',
          margin: 0,
          marginBottom: 10,
          width: "100%",
          padding: 0,
          direction: isAr ? "rtl" : "ltr",
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.6rem'
        }}>
          <span style={styles.gradient}>
            {isAr ? "شاهد سحر المنزل الذكي" : "Experience Smart Home Magic"}
          </span>
        </h2>
        <div style={{
          width: "100%",
          height: 5,
          background: "linear-gradient(90deg,#1a4bb7 70%,#2151a7 100%)",
          borderRadius: 2,
          opacity: 0.18,
          marginBottom: 24,
        }} />
        <p style={{
          width: "100%",
          color: "#3e2c8fff",
          fontSize: "1.38rem",
          fontWeight: 500,
          marginBottom: 0,
          lineHeight: 1.77,
          letterSpacing: ".003em",
          padding: 0,
          maxWidth: 500
        }}>
          {isAr
            ? "اكتشف كيف يمكن للأنظمة الذكية أن تحول تجربة منزلك وتفتح أبواب المستقبل في كل تفاصيل الحياة."
            : "Discover how smart automation reimagines your home and opens the doors to a truly inspiring future."}
        </p>
      </div>
    </>
  ) : (
    <>
      {/* Mobile: Text */}
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: isAr ? "flex-end" : "flex-start",
        justifyContent: "center",
        direction: isAr ? "rtl" : "ltr",
        textAlign: isAr ? "right" : "left",
        zIndex: 3,
        margin: 0,
        maxWidth: 520,
        width: "100%",
        padding: "1.2rem 1.2rem 1.6rem 1.2rem",
        background: "none",
        position: "relative"
      }}>
        <h2 style={{
          fontWeight: 800,
          fontSize: '1.67rem',
          letterSpacing: isAr ? 0 : '-.008em',
          textAlign: isAr ? 'right' : 'left',
          margin: 0,
          marginBottom: 10,
          width: "100%",
          padding: 0,
          direction: isAr ? "rtl" : "ltr",
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.6rem'
        }}>
          <span style={styles.gradient}>
            {isAr ? "شاهد سحر المنزل الذكي" : "Experience Smart Home Magic"}
          </span>
        </h2>
        <div style={{
          width: "100%",
          height: 5,
          background: "linear-gradient(90deg,#1a4bb7 70%,#2151a7 100%)",
          borderRadius: 2,
          opacity: 0.18,
          marginBottom: 24,
        }} />
        <p style={{
          width: "100%",
          color: "#374151",
          fontSize: "1.09rem",
          fontWeight: 500,
          marginBottom: 0,
          lineHeight: 1.77,
          letterSpacing: ".003em",
          padding: 0,
          maxWidth: 500
        }}>
          {isAr
            ? "اكتشف كيف يمكن للأنظمة الذكية أن تحول تجربة منزلك وتفتح أبواب المستقبل في كل تفاصيل الحياة."
            : "Discover how smart automation reimagines your home and opens the doors to a truly inspiring future."}
        </p>
      </div>

      {/* Mobile: Video */}
      <div style={{
        width: "100%",
        maxWidth: 650,
        aspectRatio: "16/9",
        borderRadius: 38,
        overflow: "hidden",
        background: "#193068",
        boxShadow: "0 8px 40px #19306814,0 1.5px 6px #2151a711",
        border: "4px solid #1a4bb7",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: 0,
        padding: 0,
        zIndex: 2,
        position: "relative"
      }}>
        <video
          src={SmartHomeVideo}
          autoPlay
          loop
          muted
          playsInline
          controls={false}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 34,
            background: "#1a2a4f",
            boxShadow: "none",
            border: "none"
          }}
        />
      </div>
    </>
  )}
</section>




      {/* Glance Section */}
<section id="glanceSection" className="glanceSection" style={styles.glanceSection}>
  <div style={styles.glanceOverlay}>
   <h2
  style={{
    ...styles.glanceTitle,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: isAr ? 'row-reverse' : 'row',
    textAlign: 'center',
    width: '100%',
    gap: '8px'
  }}
>
  <span style={{ fontWeight: 700 }}>
    {isAr ? 'لمحة عن ' : ''}
  </span>
  <img
    src={Mass}
    alt="Mass Logo"
    style={{
      height: '60px',
      verticalAlign: 'middle',
      margin: isAr ? '0 0 0 8px' : '0 8px 0 0'
      
    }}
  />
  <span style={{ fontWeight: 700 }}>
    {isAr ? '' : 'at a Glance'}
  </span>
</h2>




    {/* Tabs */}
    <div className="tabNav" style={styles.tabNav}>
      {glanceTranslations[isAr ? 'ar' : 'en'].tabs.map((tab, i) => (
        <span
          key={tab}
          onClick={() => setActiveTab(tab)}
          style={{
            ...styles.tabItem,
            ...styles.wordStroke,
            ...(activeTab === tab ? styles.activeTab : {}),
          }}
        >
          {tab}
        </span>
      ))}
    </div>

    {/* Tab Content */}
    <p style={styles.glanceDescription}>
      {
        glanceTranslations[isAr ? 'ar' : 'en'].content[
          // Ensure you match Arabic/English tab to content
          glanceTranslations[isAr ? 'ar' : 'en'].tabs.indexOf(activeTab) !== -1
            ? Object.keys(glanceTranslations[isAr ? 'ar' : 'en'].content)[
                glanceTranslations[isAr ? 'ar' : 'en'].tabs.indexOf(activeTab)
              ]
            : activeTab
        ]
      }
    </p>
  </div>
</section>


      {/* Services Section */}
<section
  style={{
    padding: "5rem 2rem",
    textAlign: "center",
    direction: isAr ? "rtl" : "ltr",
    fontFamily: isAr ? "'Cairo', 'Tajawal', sans-serif" : "Inter, sans-serif",
    //backgroundColor: "#fafafa",
  }}
>
  {/* Title without top border */}
  <h2
  className="partial-border-title"
  style={{
    fontSize: isAr ? 'clamp(2.2rem,5vw,3.2rem)' : 'clamp(2.2rem,6vw,3.2rem)',
    fontWeight: 900,
    marginBottom: '2.3rem',
    letterSpacing: isAr ? 0 : '0.02em',
    lineHeight: 1.2,
    textAlign: 'center',
  }}
>
  <span style={styles.gradient}>
    {currentServices.sectionTitle}
  </span>
</h2>


  {/* Introductory paragraph */}
  <p
    style={{
      maxWidth: "750px",
      margin: "0 auto 3rem",
      fontSize: "1.15rem",
      //color: '#6b7280',
      lineHeight: 1.8,
      fontWeight: 400,
    }}
  >
    {isAr
      ? "نقدم حلولاً ذكية متطورة تلائم احتياجاتك اليومية بدقة وأناقة. من الأمان والتحكم إلى الكفاءة والطاقة — خدماتنا مصممة لتجعل حياتك أكثر راحة واتصالاً."
      : "At Mass Smart Solutions, we offer a wide range of smart-home services. Here are our core areas of expertise:"}
  </p>

  {/* Services cards grid */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "2rem",
      justifyItems: "center",
    }}
  >
    {currentServices.services.map((service, index) => (
      <div
        key={index}
        style={{
          background: "#fff",
          borderRadius: "12px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
          overflow: "hidden",
          transition: "transform 0.3s ease",
          width: "100%",
          maxWidth: "350px",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-6px)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
      >
        <img
          src={
            index === 0
              ? Changemass
              : index === 1
              ? SE
              : Control
          }
          alt={service.title}
          style={{
            width: "100%",
            height: "200px",
            objectFit: "cover",
          }}
        />
        <div style={{ padding: "1.4rem" }}>
          <h3
            style={{
              fontSize: "1.2rem",
              fontWeight: 700,
              marginBottom: "0.6rem",
              color: "#222",
              direction: isAr ? "rtl" : "ltr",
            }}
          >
            {service.title}
          </h3>
          <p
            style={{
              fontSize: "0.95rem",
              color: "#555",
              marginBottom: "1rem",
              direction: isAr ? "rtl" : "ltr",
            }}
          >
            {service.description}
          </p>
          <a
            href={`${service.link}?lang=${language}`}
            style={{
              fontWeight: 600,
              color: "#004aad",
              textDecoration: "none",
              fontSize: "0.95rem",
              display: "inline-block",
              direction: isAr ? "rtl" : "ltr",
            }}
          >
            {isAr ? "المزيد →" : "Learn More →"}
          </a>
        </div>
      </div>
    ))}
  </div>
</section>




     {/* Why Mass? */}
<section
  style={{
    ...styles.productsCarousel,
    direction: isAr ? "rtl" : "ltr",
    fontFamily: isAr ? "'Cairo', 'Tajawal', Arial, sans-serif" : undefined,
  }}
>
  {/* Dark mode carousel dot styling */}
  <style>
    {`
      .dark .slick-dots li button:before {
        color: #ffffff !important;
        opacity: 0.6;
      }

      .dark .slick-dots li.slick-active button:before {
        color: #ffffff !important;
        opacity: 1;
      }

      .slick-dots li button:before {
        font-size: 12px;
        transition: all 0.3s ease;
      }
    `}
  </style>

  {/* Section Title */}
  <h2
    className="partial-border-title"
    style={{
      fontSize: isAr ? 'clamp(2.2rem,5vw,3.2rem)' : 'clamp(2.2rem,6vw,3.2rem)',
      fontWeight: 900,
      marginBottom: '2.3rem',
      letterSpacing: isAr ? 0 : '0.02em',
      lineHeight: 1.2,
    }}
  >
    <span style={styles.gradient}>
      {isAr ? "لماذا ماس؟" : "Why Mass?"}
    </span>
  </h2>

  {/* Slider */}
  <Slider {...carouselSettings}>
    {whyMassTranslations[isAr ? "ar" : "en"].map((item, index) => (
      <div key={index} style={styles.productCard}>
        <img
          src={item.image}
          alt={item.title}
          className="why-mass-icon"
          style={styles.productImage}
        />
        <p
          className="why-mass-text"
          style={{
            ...styles.productTitle,
            fontFamily: isAr ? "'Cairo', 'Tajawal', Arial, sans-serif" : undefined,
            direction: isAr ? "rtl" : "ltr",
            textAlign: "center",
          }}
        >
          {item.title}
        </p>
      </div>
    ))}
  </Slider>
</section>

      {/* Our Clients Section */}
      
{/* Our Clients Section - Arabic/English support */}
<section
  style={{
    ...styles.clientsSection,
    direction: isAr ? 'rtl' : 'ltr',
    fontFamily: isAr
      ? "'Cairo', 'Tajawal', Tahoma, Arial, sans-serif"
      : 'Poppins, sans-serif'
  }}
>
  <div style={styles.animatedClientCount}>
  </div>
  {/* City/Region Animated Tags */}
<div style={{
  display: 'flex',
  justifyContent: 'center',
  gap: '2.2rem',
  marginBottom: '1.3rem',
  flexWrap: 'wrap',
  zIndex: 1,
}}>
  {[
    { name: isAr ? 'دبي' : 'Dubai', color: '#1a4bb7' },
    { name: isAr ? 'عمان' : 'Amman', color: '#1a4bb7' },
    // Add more cities here if needed!
  ].map((city, idx) => (
    <div
      key={city.name}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '90px',
        margin: '0 0.6rem',
      }}
    >
      {/* Animated Location Icon */}
      <span
        style={{
          display: 'inline-block',
          marginBottom: '10px',
          animation: 'floatUpDown 2s ease-in-out infinite',
        }}
      >
        <FaMapMarkerAlt size={32} color={city.color} style={{
          filter: 'drop-shadow(0 2px 10px #2297e644)',
        }} />
      </span>
      {/* Tag */}
      <span
        style={{
          display: 'inline-block',
          background: `linear-gradient(90deg, #1784e6 0%, #1a4bb7 100%)`,
          color: '#fff',
          padding: '0.65rem 1.7rem',
          borderRadius: '30px',
          fontWeight: 700,
          fontSize: isAr ? '1.07rem' : '1.12rem',
          letterSpacing: '0.6px',
          boxShadow: '0 2px 16px 0 rgba(23,132,230,0.09)',
          fontFamily: isAr ? "'Cairo', sans-serif" : "'Poppins', sans-serif",
          border: 'none',
          position: 'relative',
          transition: 'transform 0.23s cubic-bezier(.48,1.7,.36,.83), box-shadow 0.2s',
          cursor: 'default',
        }}
        onMouseOver={e => {
          e.currentTarget.style.transform = 'translateY(-4px) scale(1.06)';
          e.currentTarget.style.boxShadow = '0 8px 20px 0 #1784e63b';
        }}
        onMouseOut={e => {
          e.currentTarget.style.transform = '';
          e.currentTarget.style.boxShadow = '0 2px 16px 0 rgba(23,132,230,0.09)';
        }}
      >
        {city.name}
      </span>
    </div>
  ))}
</div>

  <h2 className="partial-border-title">
    <span style={styles.gradient}>
      {clientSectionTranslations[isAr ? 'ar' : 'en'].pioneers}
    </span>
  </h2>
  <p style={styles.clientsSubtitle}>
    {clientSectionTranslations[isAr ? 'ar' : 'en'].pioneersDesc}
  </p>
  <div style={styles.clientsGrid}>
    {[Damac, Alshafi, TCF, Telescope, Yasser, TimeZone, MapCanada, Hammer, Lucera, Leen, Vibranum, IRIS, Concept, agency, Rahaf,Albeer,Alfurjan,Hills,PlanB,Zaaabeel].map((logo, idx) => (
      <div
        key={idx}
        style={styles.clientCard}
        onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.05)')}
        onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
      >
        <img src={logo} alt={`Client ${idx + 1}`} style={styles.clientLogo} />
      </div>
    ))}
  </div>
</section>

<section
  style={{
    padding: '3rem 2rem',
    //background: '#f4f8ff',
    textAlign: 'center',
    fontFamily: isAr ? "'Cairo', sans-serif" : "'Poppins', sans-serif",
    direction: isAr ? 'rtl' : 'ltr',
  }}
>
 <h2
  className="partial-border-title"
  style={{
    fontSize: isAr ? 'clamp(2.4rem,5vw,3.2rem)' : 'clamp(2.4rem,6vw,3.2rem)',
    fontWeight: 800,
    marginBottom: '2.3rem',
    lineHeight: 1.3,
    textAlign: 'center',
  }}
>
  <span style={styles.gradient}>
    {isAr
      ? 'موضع ثقة أكثر من ١٠٠ عميل في المنطقة'
      : 'Trusted by 100+ Clients Across the Region'}
  </span>
</h2>



  <div
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '3rem',
      marginTop: '2rem',
    }}
  >
    {/* Clients */}
    <div style={{ textAlign: 'center', animation: 'fadeInUp 1s ease-in-out' }}>
      <FaUsers size={48} style={{ color: '#1a4bb7', marginBottom: '1rem' }} />
      <h3
        style={{
          fontSize: '2.6rem',
          fontWeight: 800,
          color: '#1a4bb7',
          animation: 'pulseGlow 2s infinite ease-in-out',
        }}
      >
        +{clients}
      </h3>
      <p style={{ fontSize: '1.1rem', color: '#6b7280' }}>
        {isAr ? 'عميل موثوق' : 'Clients'}
      </p>
    </div>

    {/* Instagram */}
    <div style={{ textAlign: 'center', animation: 'fadeInUp 1.2s ease-in-out' }}>
      <FaInstagram size={48} style={{ color: '#C13584', marginBottom: '1rem' }} />
      <h3
        style={{
          fontSize: '2.6rem',
          fontWeight: 800,
          color: '#C13584',
          animation: 'pulseGlow 2s infinite ease-in-out',
        }}
      >
        {insta.toLocaleString()}
      </h3>
      <p style={{ fontSize: '1.1rem', color: '#6b7280' }}>
        Instagram {isAr ? 'متابع' : 'Followers'}
      </p>
    </div>

    {/* Facebook */}
    <div style={{ textAlign: 'center', animation: 'fadeInUp 1.4s ease-in-out' }}>
      <FaFacebookF size={48} style={{ color: '#1877f2', marginBottom: '1rem' }} />
      <h3
        style={{
          fontSize: '2.6rem',
          fontWeight: 800,
          color: '#1877f2',
          animation: 'pulseGlow 2s infinite ease-in-out',
        }}
      >
        {fb.toLocaleString()}
      </h3>
      <p style={{ fontSize: '1.1rem', color: '#6b7280' }}>
        Facebook {isAr ? 'متابع' : 'Followers'}
      </p>
    </div>
  </div>
</section>


      {/* Logo Scroll Section */}
      <section style={styles.logoScrollSection}>
      <h2
  className="partial-border-title"
  style={{
    fontSize: 'clamp(1.3rem, 7vw, 2.7rem)', // responsive, bigger on mobile
    fontWeight: 900,
    marginBottom: '2.3rem',
    letterSpacing: isAr ? 0 : '0.02em',
    lineHeight: 1.2,
    direction: isAr ? "rtl" : "ltr",
    fontFamily: isAr ? "'Cairo','Tajawal',Arial,sans-serif" : undefined,
  }}
>
  <span style={styles.gradient}>
    {proudTranslations[isAr ? "ar" : "en"]}
  </span>
</h2>


        <div style={styles.logoScrollWrapper}>
          <div className="logoScrollInner" style={styles.logoScrollInner}>
            {[...partnerLogos, ...partnerLogos].map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt={`Partner Logo ${index + 1}`}
                style={styles.partnerLogo}
              />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

const styles = {
  container: {
    fontFamily: "'Segoe UI', sans-serif",
    width: '100%',
    overflowX: 'hidden',
    margin: 0,
    padding: 0,
  },
  hero: {
    position: 'relative',
    width: '100%',
    minHeight: '88vh',   // <--- changed from 100vh
    height: '80vh',      // <--- changed from 100vh
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 0,
    padding: 0,
  },
  heroVideo: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    filter: 'brightness(0.6)',
    zIndex: 1,
    pointerEvents: 'none',
    transition: 'opacity 1s ease-in-out', // ✨ fade effect
    opacity: 1,
  },
    heroOverlay: {
      position: 'relative',
      zIndex: 2,
      textAlign: 'center',
      color: '#fff',
      padding: '0 2rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  sliderContainer: {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
},

sliderTrack: {
  display: 'flex',
  width: '300%',
  height: '100%', // 👈 this is good
  transition: 'transform 1s ease-in-out',
},


  
  heroTitle: {
  fontSize: 'clamp(2rem, 5vw, 4rem)',
  fontWeight: 'bold',
  marginBottom: '1rem',
  color: '#fff',
  textShadow: `
    -1px -1px 0 #000,  
     1px -1px 0 #000,
    -1px  1px 0 #000,
     1px  1px 0 #000
  `,
},

  heroSubtitle: {
    fontSize: 'clamp(1rem, 3vw, 1.5rem)',
    marginBottom: '2rem',
    
  },
  ctaButton: {
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: 'transparent',
  color: '#ffffff',
  border: '2px solid #1a4bb7', // ⬅️ black border
  padding: '0.8rem 2rem',
  fontSize: '1.1rem',
  fontWeight: '600',
  borderRadius: '30px',
  cursor: 'pointer',
  transition: 'color 0.4s ease',
  zIndex: 1,
  textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000' // ⬅️ black outline for white text
},


  scrollDown: {
    position: 'absolute',
    bottom: '30px',
    left: '30px',
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    //backgroundColor: 'rgba(255, 255, 255, 0.15)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    animation: 'bounce 2s infinite',
    zIndex: 3,
  },
  glanceSection: {
  position: 'relative',
  backgroundImage: `url(${Glace})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  width: '100%',
  padding: '2rem 1rem',
  marginTop: '60px',
  color: '#fff',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end', // Keep as is, but control with isAr
  alignItems: 'center',
  minHeight: '400px',
},



glanceOverlay: {
  width: '100%',
  maxWidth: '600px', // Optional: adjust width
  padding: '1.5rem 2rem',
  textAlign: 'center', // ⬅️ align text left
  backgroundColor: 'rgba(70, 62, 62, 0.5)',
  borderRadius: '16px',
  animation: 'fadeInUp 1.5s ease-in-out',
  boxShadow: '0 8px 20px rgba(110, 99, 99, 0.4)',
  marginLeft: '2rem', // push left
  marginRight: 'auto', // no space on right
},



  tagline: {
    fontSize: '1.1rem',
    color: '#1a4bb7',
  },
glanceTitle: {
  fontSize: 'clamp(1.5rem, 5vw, 2.5rem)',
  marginBottom: '1.5rem',
  color: 'white',
  textAlign: 'center', // ✅ fixes heading alignment
},

  tabNav: {
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '1.5rem',
  marginBottom: '1.5rem',
  borderBottom: '2px solid rgb(46, 126, 200)',
  paddingBottom: '0.5rem',
},

  tabItem: {
  fontSize: '1rem',
  paddingBottom: '0.5rem',
  cursor: 'pointer',
  color: 'white',
  borderBottom: '3px solid transparent',
  transition: 'all 0.3s ease',
},
  activeTab: {
  fontSize: '1.2rem',
  color: 'white',
  fontWeight: '700',
  borderBottom: '3px solid #1a4bb7',
},
  glanceDescription: {
  fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
  lineHeight: '1.6',
  color: 'white',
  animation: 'fadeInUp 1s ease-in-out',
},

  featuresSection: {
    padding: '4rem 2rem',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    gap: '4rem',
  },
  feature: {
    display: 'flex',
    alignItems: 'center',
    gap: '3rem',
    flexWrap: 'wrap',
  },
  featureReverse: {
    display: 'flex',
    alignItems: 'center',
    gap: '3rem',
    flexWrap: 'wrap',
    flexDirection: 'row-reverse',
  },
  featureImage: {
    width: '100%',
    maxWidth: '450px',
    borderRadius: '20px',
  },
  featureText: {
    flex: '1',
    minWidth: '300px',
  },
  featureTitle: {
    fontSize: '2rem',
    fontWeight: '700',
  },
  featureDescription: {
    fontSize: '1.1rem',
    lineHeight: '1.6',
  },
  logoScrollSection: {
    padding: '3rem 1rem',
    textAlign: 'center',
    //backgroundColor: 'white', // REMOVE this line if it exists!
  },
  logoTitle: {
    fontSize: '2rem',
    color: 'Black',
    marginBottom: '2rem',
  },
  logoScrollWrapper: {
    overflow: 'hidden',
  },
  logoScrollInner: {
  display: 'flex',
  gap: '60px',
  animation: 'scrollLeft 18s linear infinite',
  minWidth: '360%',
  flexWrap: 'nowrap',
},

  partnerLogo: {
    height: '120px',
    maxWidth: '200px',
    padding: '0px',
    backgroundColor: 'transparent',
    borderRadius: '0',
    objectFit: 'contain',
    boxShadow: 'none',
    flexShrink: 0,
    transition: 'transform 0.3s, filter 0.3s',
},

  ctaSection: {
    backgroundColor: '#00ffc3',
    color: '#000',
    textAlign: 'center',
    padding: '4rem 2rem',
  },
  ctaTitle: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
  },
  ctaText: {
    fontSize: '1.2rem',
    maxWidth: '600px',
    margin: '0 auto 2rem',
  },
  animatedHeader: {
  width: '100%',
  paddingTop: '2.6rem',
  fontSize: '1.2rem',
  fontWeight: 800,
  textAlign: 'center',
  
},

 animatedTitle: {
  fontSize: 'clamp(1rem, 1vw, 1rem)',
  fontWeight: '800',
  background: 'linear-gradient(to right, #1784e6 0%, #1a4bb7)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  textAlign: 'center',
  animation: 'fadeInUp 2s ease-out',
  letterSpacing: '1px',
  lineHeight: '1.3',
},

  productsCarousel: {
    //backgroundColor: "#fff",
    padding: "4rem 2rem",
    textAlign: "center",
  },
  productCard: {
    //background: "#f7f7f7",
    borderRadius: "16px",
    padding: "2rem 1rem",
    textAlign: "center",
    margin: "0 auto",
    transition: "transform 0.3s ease",
    boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
  },

  productImage: {
    width: '100px',
    height: '100px',
    marginBottom: '1rem',
  },
  productTitle: {
    fontSize: '1.1rem',
    fontWeight: '600',
    color: '#333',
  },
  servicesSection: {
    padding: '4rem 2rem',
    //backgroundColor: 'White',
    textAlign: 'center',
  },
  servicesTitle: {
    fontSize: '2.3rem',
    fontWeight: 'bold',
    marginBottom: '3rem',
    color: '#000',
  },
  servicesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '2rem',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  serviceCard: {
    //background: 'white',
    borderRadius: '12px',
    padding: '2rem 1rem',
    boxShadow: '0 6px 16px rgba(0,0,0,0.06)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  serviceIcon: {
    width: '60px',
    height: '60px',
    marginBottom: '1rem',
  },
  serviceTitle: {
    fontSize: '1.1rem',
    fontWeight: '600',
    color: '#333',
  },
 clientsSection: {
  // ...existing
  textAlign: 'center',
  padding: '5rem 1rem',
  
},

  clientsTitle: {
    fontSize: '2.3rem',
    fontWeight: '700',
    marginBottom: '1rem',
    color: '#0d1a26',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  clientsSubtitle: {
    fontSize: '1rem',
    //color: '#6b7280',
    marginBottom: '2.5rem',
    lineHeight: '1.6',
    maxWidth: '700px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  clientsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
    gap: '1.5rem',
    justifyContent: 'center',
    maxWidth: '900px',
    margin: '0 auto',
    alignItems: 'center',
  },
  clientCard: {
    borderRadius: '12px',
    padding: '1.5rem',
    
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    height: '160px',
    //cursor: 'pointer',
    animation: 'fadeInCard 0.8s ease both',
  },
  clientLogo: {
    maxHeight: '130px',
    maxWidth: '130%',
    objectFit: 'cover',
    filter: 'grayscale(0%)',
    transition: 'transform 0.3s ease, filter 0.3s ease',
  },
  highlight: {
    color: '#1a4bb7', // Mass blue
  },
  clientCount: {
    fontSize: '1.3rem',
    color: '#1a4bb7',
    fontWeight: '600',
    marginBottom: '1.5rem',
  },
  clientStatsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '2rem',
  },
  clientCountNumber: {
    fontSize: '3rem',
    fontWeight: '700',
    color: '#1a4bb7',
    animation: 'countUp 1.5s ease-out',
  },
  clientCountLabel: {
    fontSize: '1.1rem',
    fontWeight: '500',
    color: '#333',
    marginTop: '0.5rem',
  },
  animatedClientCount: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '3rem',
    animation: 'fadeInUp 1.4s ease both',
  },
  countNumber: {
    fontSize: '3rem',
    fontWeight: '800',
    color: '#1a4bb7',
    animation: 'pulseGlow 2s infinite ease-in-out',
    letterSpacing: '2px',
  },
  countLabel: {
    fontSize: '1.2rem',
    fontWeight: '600',
    color: '#444',
    borderBottom: '2px solid #1a4bb7',
    paddingBottom: '0.4rem',
    marginTop: '0.5rem',
  },
 heroMedia: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    flexShrink: 0,
    flex: '0 0 100%',
  },


  arrowButton: {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'none',           // بدون خلفية
  color: '#1769c6',             // لون أزرق واضح (غير أسود)
  border: 'none',
  padding: '0.1rem 0.7rem',     // صغير، فقط للمسافة حول السهم
  borderRadius: '50%',
  fontSize: '2.7rem',           // السهم أكبر
  fontWeight: 900,
  zIndex: 3,
  cursor: 'pointer',
  outline: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'color 0.17s, transform 0.12s',
  opacity: 0.93,
  userSelect: 'none',
},

  heroVideoWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    zIndex: 1,
  },
 heroSubline: {
  fontSize: 'clamp(1rem, 3vw, 1.5rem)',
  marginBottom: '2rem',
  color: '#fff',
  textShadow: `
    -1px -1px 0 #000,  
     1px -1px 0 #000,
    -1px  1px 0 #000,
     1px  1px 0 #000
  `,
},
heading: {
    fontSize: '2.2rem',
    fontWeight: 800,
    textAlign: 'center',
    marginBottom: '3.5rem',
  },
 gradient: {
    background: 'linear-gradient(to right, #1784e6 0%, #1a4bb7)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
},
 massHighlight: {
  padding: '0.2rem 0.8rem',
  border: '2px solid white',
  borderRadius: '30px',
  color: '#1a4bb7',
  fontWeight: '700',
  fontSize: '1.1em',
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  display: 'inline-block',
  animation: 'fadeInUp 1s ease-in-out',
  textShadow: `
    -1px -1px 0 #000,
     1px -1px 0 #000,
    -1px  1px 0 #000,
     1px  1px 0 #000
  `,
},
wordStroke: {
  color: '#ffffff',
  display: 'inline-block',
  fontWeight: '500',
},
scrollTopBtn: {
  position: 'fixed',
  bottom: '25px',
  left: '25px',
  width: '48px',
  height: '48px',
  borderRadius: '50%',
  backgroundColor: 'rgba(0,0,0,0.5)',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  zIndex: 999,
  boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
  transition: 'opacity 0.3s ease',
},


};

export default SmartHomeIntro;
